import { ReactNode } from 'react';
import { Channel as ChannelType } from 'stream-chat';
import { ChannelProps } from 'stream-chat-react';

import { ChannelProvider } from 'src/features/channel/ChannelProvider';
import { InnerChannelContent } from 'src/features/channel/InnerChannelContent';

interface InnerChannelProps {
  MessageNotification?: ChannelProps['MessageNotification'];
  EmptyStateIndicator?: ChannelProps['EmptyStateIndicator'];
  channel?: ChannelType;
  markReadOnMount?: boolean;
  children: ReactNode;
}

/**
 * Backward-compatible wrapper that includes both the Channel provider and Window.
 * For new code in features/, use ChannelProvider and InnerChannelContent separately
 * to allow hoisting the provider.
 *
 * @deprecated Use ChannelProvider and InnerChannelContent directly for better provider control
 */
export const InnerChannel = ({
  MessageNotification,
  EmptyStateIndicator,
  channel,
  markReadOnMount,
  children,
}: InnerChannelProps) => {
  return (
    <ChannelProvider
      MessageNotification={MessageNotification}
      EmptyStateIndicator={EmptyStateIndicator}
      channel={channel}
      markReadOnMount={markReadOnMount}
    >
      <InnerChannelContent channel={channel}>{children}</InnerChannelContent>
    </ChannelProvider>
  );
};
